module.exports = __webpack_public_path__ + "ead9771e3bae09686730b26b23f1b024.jpg";


//////////////////
// WEBPACK FOOTER
// ../~/file-loader!../loaders/scale-loader?size=410!./images/projekte/theater-2014.jpg
// module id = 535
// module chunks = 0